import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { Icon, MenuList, MenuItem } from '@material-ui/core';
import apiService from '../../services.js/apiService';
import BusinessProfile from './BusinessProfile';
import Staffs from './StaffTable';
import Overview from './Overview';

const Business = (props) => {
  const [redirect, setRedirect] = useState(false);
  const [bizPage, setBizPage] = useState([]);
  const [currentSelected, setCurrentSelected] = useState('');

  useEffect(() => {
    (async () => {
      if (props.match.params.pageId) {
        const page = await apiService.getPageById(props.match.params.pageId);
        if (page) {
          setBizPage(page);
          setCurrentSelected('overview');
        }
      }
    })();
  }, []);

  return redirect ? <Redirect to="/admin/business" /> : (
    <>
      <div className="row" style={{}}>
        <div className="col-md-12">
          <div className="content-header">
            <h1 className="d-flex align-items-center">
              <div onClick={() => { setRedirect(true); }} className="d-flex align-items-center" aria-hidden="true">
                <Icon className="back">arrow_back</Icon>
              </div>
              {`Business / ${bizPage.name || ''}`}
            </h1>
          </div>

          <div className="row">
            <div className="col-md-2" style={{ backgroundColor: '#fff' }}>
              <MenuList>
                <Link href onClick={() => { setCurrentSelected('overview'); }}><span><MenuItem>Overview</MenuItem></span></Link>
                <Link href onClick={() => { setCurrentSelected('business-profile'); }}><span><MenuItem>Business Profile</MenuItem></span></Link>
                <Link href onClick={() => { setCurrentSelected('staffs'); }}><span><MenuItem>Staffs</MenuItem></span></Link>
              </MenuList>
            </div>

            <div className="col-md-10 card-left">
              { currentSelected === 'overview' && (
              <>
                <h1>Overview</h1>
                <Overview pageId={bizPage.id} />
              </>
              )}

              { currentSelected === 'business-profile' && (
              <>
                <h1>Business Profile</h1>
                <BusinessProfile pageId={bizPage.id} />
              </>
              )}

              { currentSelected === 'staffs' && (
              <>
                <h1>Staffs</h1>
                <Staffs pageId={bizPage.id} />
              </>
              )}

              { currentSelected === 'page-claims' && (
              <>
                <h1>Page Claims</h1>
                {/* <PageClaims pageId={bizPage.id} /> */}
              </>
              )}
            </div>

          </div>
        </div>
      </div>

    </>
  );
};

Business.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      pageId: PropTypes.number,
    }),
  }).isRequired,
};

export default connect(null, null)(Business);
